import React from 'react';
import { ArrowRight } from 'lucide-react';

interface NarrativeBridgeProps {
  title: string;
  description?: string;
  ctaText?: string;
  ctaAction?: () => void;
}

const NarrativeBridge: React.FC<NarrativeBridgeProps> = ({
  title,
  description,
  ctaText = "Learn More",
  ctaAction
}) => {
  return (
    <section className="relative py-16 lg:py-24 bg-navy-950 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-accent-orange rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-primary-600 rounded-full blur-3xl" />
      </div>

      <div className="container-main relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-white font-heading mb-6">
            {title}
          </h2>
          {description && (
            <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
              {description}
            </p>
          )}
          {ctaAction && (
            <button
              onClick={ctaAction}
              className="group inline-flex items-center gap-2 text-accent-orange hover:text-orange-400 transition-colors text-lg font-semibold"
            >
              {ctaText}
              <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
            </button>
          )}
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center">
          <div className="w-1.5 h-3 bg-white/50 rounded-full mt-2 animate-bounce" />
        </div>
      </div>
    </section>
  );
};

export default NarrativeBridge;
